<template>
  <div class="text-white">
    <button
      :type="type"
      :style="{ background: themePrimaryColor }"
      :disabled="isDisabled"
      :class="[
        isFullWidth ? 'w-full' : 'w-full md:w-134 md:mx-auto',
        isDisabled ? 'opacity-50 cursor-not-allowed' : 'opacity-100',
      ]"
      class="
        p-8
        text-center text-base
        font-medium
        cursor-pointer
        relative
        block
        group
        rounded-md
      "
    >
      <span class="z-10 relative">{{ title }}</span>
      <div
        class="
          absolute
          z-0
          bg-black
          w-full
          h-full
          left-0
          top-0
          xl:group-hover:opacity-20
          opacity-0
        "
      ></div>
    </button>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

@Component({})
export default class Button extends Vue {
  @Prop() title!: string
  @Prop() isFullWidth!: boolean
  @Prop() isDisabled!: boolean
  @Prop({ default: 'button' }) type!: 'button' | 'submit'

  @Getter themePrimaryColor!: string
}
</script>
